import { debug } from '../../../utils/debug';
import { IExpression } from '../IExpression';
import { evaluateExpression } from './evaluateExpression';
import { IMaterializedReference } from './materializeReferencePath';
import { IEvaluationVariables } from './variables/IEvaluationVariables';

/**
 * Forniti i dati di un'espressione, restituisce il valore calcolato.
 */
export function getExpressionValue(input: {
  name: string;
  expression: IExpression | null | undefined;
  references: IMaterializedReference[];
  variables: IEvaluationVariables;
}) {
  const { name, expression, variables } = input;
  if (!expression) return { type: 'null' as const };

  debug.log(`expression.evaluate.get`, 'getExpressionValue params:', { name, expression, variables }); // prettier-ignore

  const result = evaluateExpression(expression, {
    variables,
  });
  debug.log(`expression.evaluate.get`, 'getExpressionValue result:', { result, variables }); // prettier-ignore
  return { type: 'value' as const, result };
}

/**
 * Funzione utilizzata quando dobbiamo assumere che un valore `null` è true,
 * casi di esempio:
 * - `visible: null` -> visibile
 * - regola condizionale su RTE null -> visibile
 */
export function isExpressionValueActive(
  expressionValue: ReturnType<typeof getExpressionValue>,
) {
  return !(
    expressionValue.type === 'value' && expressionValue.result === false
  );
}
